import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import CTAList from './CTAList'
import IconAndText from 'components/common/IconAndText'
import clsx from 'clsx'

export default function FeaturesWithIcons({
	pretitle,
	title,
	_rawContent,
	cta,
	cta2,
	items,
	stacked,
	style,
}) {
	return (
		<section className={clsx(style === 'white' && 'bg-white')}>
			<div
				className={clsx(
					'ctnr padding grid gap-x-16 gap-y-24',
					stacked ? 'md:grid-cols-2' : 'md:grid-cols-[1fr,2fr]',
				)}
			>
				<div className="md:sticky-below-header [&_h2]:h1 grid gap-4 self-start">
					{pretitle && <p className="technical-lg">{pretitle}</p>}
					{title && <h2 className="h1">{title}</h2>}
					<SanityBlock body={_rawContent} />
					<CTAList ctas={[cta, cta2]} />
				</div>

				<div
					className={clsx(
						'grid gap-x-8 gap-y-16 <md:gap-y-16',
						stacked
							? 'mx-auto'
							: 'grid-cols-[repeat(auto-fill,minmax(300px,1fr))]',
					)}
				>
					{items.map(({ description, ...item }, key) => (
						<IconAndText
							{...item}
							className={clsx(
								stacked ? 'max-w-md text-balance' : 'w-full <md:max-w-sm',
							)}
							key={key}
						>
							{description}
						</IconAndText>
					))}
				</div>
			</div>
		</section>
	)
}
